@if (!isError()) {
    <div
        class="form-group crm-tags"
        [class.block-loading]="isLoading()"
        [tooltip]="tags().length ? '' : ('crm_tags_empty_hint' | translate)"
        [tooltipAppendToBody]="true"
    >
        <div [class.disabled]="!tags().length">
            <ng-select
                class="sp-ng-select"
                [class.btn-loading]="isLoading()"
                [items]="tags()"
                [multiple]="true"
                [closeOnSelect]="false"
                [clearable]="false"
                bindLabel="name"
                bindValue="id"
                [ngModelOptions]="{ standalone: true }"
                [ngModel]="tagsForm().value()"
                (ngModelChange)="onTagIdsChange($event)"
                [placeholder]="'choose_tags' | translate"
                [hideSelected]="true"
            >
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    @for (item of items; track item) {
                        <span class="crm-tag-pill" [ngStyle]="getTagStyles(item)">
                            <span class="crm-tag-text">{{ item.name || ("crm_tag_deleted" | translate) }}</span>
                            <span class="crm-tag-remove" (click)="clear(item)" aria-hidden="true">×</span>
                        </span>
                    }
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                    <span class="crm-tag-pill" [ngStyle]="getTagStyles(item)">
                        <span class="crm-tag-text">{{ item.name || ("crm_tag_deleted" | translate) }}</span>
                    </span>
                </ng-template>
            </ng-select>
        </div>
    </div>
} @else {
    <div class="alert alert-danger">
        {{ "unknown_error" | translate }}
    </div>
}
